module.exports = __webpack_public_path__ + "static/media/analyze_contract.471fb15b.svg";